import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Divider,
  Box,
  Stack,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import "./Vehicle.scss";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchBookingById,
  fetchBookingByVehicleId,
  fetchIncomeByVehicleId,
  fetchVehicleById,
} from "../../store/slices/thunk";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { FaEye } from "react-icons/fa";
import Loader from "../../components/loader";
import weblogo from "../../assets/weblogo.png";

const VehicleCard = () => {
  const { id } = useParams<any>();
  const [getVehicleById, setGetVehicleById] = useState<any>({});
  const [getAllBookingById, setGetAllBooking] = useState<any>({});
  const [getAllIncome, setGetAllIncome] = useState<any>([]);
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  // const [pageTwo, setPageTwo] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const ITEMS_PER_PAGE = 10;
  const [totalCount, setTotalCount] = useState(0);
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  
  const toastShownRef = useRef({
    vehicle: false,
    booking: false,
  });
  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        const response: any = await dispatch(fetchVehicleById(id));
        if (response && response.data) {
          if (!toastShownRef.current.vehicle) {
            toast.success("Vehicle details successfully");
            toastShownRef.current.vehicle = true;
          }
          setGetVehicleById(response.data);
        } else {
          setGetVehicleById({});
          toast.error("Failed to fetch vehicle details");
        }
      } else {
        toast.error("Vehicle ID is not provided");
      }
    };
    fetchData();
  }, [id, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsLoading(true);
        const response: any = await dispatch(
          fetchBookingByVehicleId(page, ITEMS_PER_PAGE, id, "")
        );
        if (response && response.data.length > 0) {
          if (!toastShownRef.current.booking) {
            toast.success("Booking Found successfully");
            toastShownRef.current.booking = true;
          }
          setGetAllBooking(response.data);
          setTotalCount(response.data.length || 0);
          setIsLoading(false);
        } else {
          setGetAllBooking([]);
          toast.error("Booking Not Found");
          setIsLoading(false);
        }
      } else {
        toast.error("Vehicle ID is not provided");
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id, dispatch]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (id) {
  //       const response: any = await dispatch(
  //         fetchIncomeByVehicleId(pageTwo, 10, id, "")
  //       );
  //       if (response && response.data.length > 0) {
  //         toast.success("Income Found successfully");
  //         setGetAllIncome(response.data);
  //       } else {
  //         setGetAllIncome([]);
  //         toast.error("Income Not Found");
  //       }
  //     } else {
  //       toast.error("Vehicle ID is not provided");
  //     }
  //   };
  //   fetchData();
  // }, [id, dispatch]);

  // const data = {
  //   registrationNo: "dawerdrew",
  //   name: "drew",
  //   model: "35",
  //   chassisNo: "12345678",
  //   engineNo: "12345678",
  //   manufacturedBy: "kia",
  //   type: "CAR",
  //   mileagePerLitre: "0",
  //   apiUrl: "https://codeforts.com/vms/api",
  //   gpsUsername: "dawerdrew",
  //   gpsPassword: "796423",
  //   createdDate: "2024-12-16 02:25:44",
  //   modifiedDate: "2024-12-16 14:26:40",
  //   document: "-",
  // };
  // const bookings = [
  //   {
  //     id: 1,
  //     driver: "Yet to Assign",
  //     customer: "andrew",
  //     from: "jose",
  //     to: "eduardo",
  //     value: 20.0,
  //     status: "Yet to start",
  //   },
  // ];
  const [activeTab, setActiveTab] = useState("basicinfo");
  const tabs = [
    { id: "basicinfo", label: "Basic info" },
    { id: "bookings", label: "Bookings" },
    // { id: "geofence", label: "Geofence" },
    // { id: "income", label: "Income & Expense" },
  ];
  function createData(
    name: string,
    calories: number,
    fat: number,
    carbs: number,
    protein: number
  ) {
    return { name, calories, fat, carbs, protein };
  }
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  // const rows = [
  //   createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  //   createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  //   createData("Eclair", 262, 16.0, 24, 6.0),
  //   createData("Cupcake", 305, 3.7, 67, 4.3),
  //   createData("Gingerbread", 356, 16.0, 49, 3.9),
  // ];
  const gotoDetails = (id: string) => {
    navigate(`/view-detail/${id}`);
  };
  const renderContent = () => {
    switch (activeTab) {
      case "basicinfo":
        return (
          <div className="main-ContentDV">
            <ToastContainer />{" "}
            <div className="tabar-content">
              <div className="container mt-4">
                <div className="card">
                  <div className="card-body">
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <th>
                            <p>Registration No</p>{" "}
                          </th>
                          <td>{getVehicleById.registrationNumber || "--"}</td>
                        </tr>
                        <tr>
                          <th>
                            <p>Name</p>
                          </th>
                          <td>{getVehicleById.vehicleName || "--"}</td>
                        </tr>
                        <tr>
                          <th>Model</th>
                          <td>{getVehicleById.model || "--"}</td>
                        </tr>
                        <tr>
                          <th>Chassis No.</th>
                          <td>{getVehicleById.chassisNo || "--"}</td>
                        </tr>
                        <tr>
                          <th>Engine No.</th>
                          <td>{getVehicleById.engineNo || "--"}</td>
                        </tr>
                        <tr>
                          <th>Manufactured By</th>
                          <td>{getVehicleById.manufacturedBy || "--"}</td>
                        </tr>
                        <tr>
                          <th>Type</th>
                          <td>{getVehicleById.vehicleType || "--"}</td>
                        </tr>
                        <tr>
                          <th>Mileage/Litre</th>
                          <td>{getVehicleById.mileagePerLitre || 0}</td>
                        </tr>
                        {/* <tr>
                          <th>API URL</th>
                          <td>
                            <a
                              href={getVehicleById.apiUrl || '--'}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {getVehicleById.apiUrl || '--'}
                            </a>
                          </td>
                        </tr> */}
                        {/* <tr>
                          <th>GPS API Username</th>
                          <td>{getVehicleById.gpsUsername || '--'}</td>
                        </tr> */}
                        {/* <tr>
                          <th>GPS API Password</th>
                          <td>{getVehicleById.gpsPassword || '--'}</td>
                        </tr> */}
                        <tr>
                          <th>Created Date</th>
                          <td>
                            {getVehicleById.createdOn
                              ? new Date(
                                  getVehicleById.createdOn
                                ).toLocaleDateString("en-GB")
                              : "--"}
                          </td>
                        </tr>
                        <tr>
                          <th>Modified Date</th>
                          <td>{getVehicleById.modifiedDate || "--"}</td>
                        </tr>
                        <tr>
                          <th>Document</th>
                          
                          
                          <td>
                            <a href={getVehicleById.vehicleDocument} target="blank">See Document</a>
                            {/* {getVehicleById.vehicleDocument || "--"} */}
                            </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <div className="d-flex justify-content-end mb-4">
                      <button
                        className="btn mt-3 me-4"
                        style={{
                          background: "#4285F4",
                          fontWeight: "600",
                          color: "white",
                        }}
                      >
                        Edit Info
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case "bookings":
        return (
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <div className="table-scroll-x" style={{ flex: 1, overflow: "auto" }}>
              <Table className="table tableforit">
                <TableHead className="th">
                  <TableRow className="table-h-row">
                    <TableCell
                      className="table-cell p-0"
                      style={{
                        backgroundColor: "#f9fafb",
                        color: "#6b7280",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      Trip Name
                    </TableCell>
                    <TableCell
                      className="table-cell p-0"
                      style={{
                        backgroundColor: "#f9fafb",
                        color: "#6b7280",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      Driver
                    </TableCell>
                    <TableCell
                      className="table-cell p-0"
                      style={{
                        backgroundColor: "#f9fafb",
                        color: "#6b7280",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      Route
                    </TableCell>
                    <TableCell
                      className="table-cell p-0"
                      style={{
                        backgroundColor: "#f9fafb",
                        color: "#6b7280",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      Start Time
                    </TableCell>
                    <TableCell
                      className="table-cell p-0"
                      style={{
                        backgroundColor: "#f9fafb",
                        color: "#6b7280",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      Passengers
                    </TableCell>
                    <TableCell
                      className="table-cell p-0"
                      style={{
                        backgroundColor: "#f9fafb",
                        color: "#6b7280",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      className="table-cell p-0"
                      style={{
                        backgroundColor: "#f9fafb",
                        color: "#6b7280",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Loader />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody>
                    {getAllBookingById.map((booking: any, index: number) => (
                      <TableRow className="t-row" key={index}>
                        <TableCell>{booking?.tripName || "--"}</TableCell>
                        {/* {booking.customer.map((customer: any) => (
                    <ul className="p-0 mt-4 text-black">
                      <li className="text-black">{customer.customerName || "--"}</li>
                    </ul>
                    )) || "--"} */}

                        <TableCell className=" align-items-center">
                          <div className="d-flex" style={{ height: "40px" }}>
                            <img
                              src={booking?.driver?.driverImage || weblogo}
                              style={{ objectFit: "cover", width: "40px", height: "40px" }}
                              className="rounded-circle"
                            />
                                                      <Chip
                            label={booking?.driver?.driverName || "--"}
                            style={{
                              padding: "5px",
                              background: "#fff",
                              fontSize: ".875rem",
                            }}
                            size="small"
                          />
                          </div>

                        </TableCell>
                        <TableCell>
                          <span>
                            {booking?.startLocation?.streetAddress
                              ? String(
                                  booking.startLocation.streetAddress
                                ).slice(0, 20) + "..."
                              : "--"}
                          </span>
                          <span style={{ marginLeft: "5px" }}>To</span>
                          <span style={{ marginLeft: "5px" }}>
                            {booking?.endLocation?.streetAddress
                              ? String(booking.endLocation.streetAddress).slice(
                                  0,
                                  20
                                ) + "..."
                              : "--"}
                          </span>
                        </TableCell>
                        <TableCell className="table-cel4">
                          {booking?.startTime
                            ? new Date(booking?.startTime).toLocaleTimeString(
                                "en-US",
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                }
                              )
                            : "--"}
                        </TableCell>

                        <TableCell>{booking?.customer.length || 0}</TableCell>
                        <TableCell>
                          {/* <select
                      value={booking.tripStatus}
                      style={{borderRadius:"30px",paddingTop:"10px",paddingBottom:"10px"}}
                      onChange={(e: any) => handleUpdateStatus(booking._id, e.target.value)}
                    >
                      <option value="yetToStart">Active</option>
                      <option value="completed">Completed</option>
                      <option value="onGoing">In Progress</option>
                      <option value="cancelled">Schedule</option>
                     
                    </select> */}
                          {booking.tripStatus === "yetToStart" && (
                            <span
                              className="px-2 py-1 rounded-pill fw-semibold"
                              style={{
                                backgroundColor: "#dbeafe",
                                color: "#1e40af",
                                fontSize: "0.75rem",
                              }}
                            >
                              In-Progress
                            </span>
                          )}

                          {booking.tripStatus === "onGoing" && (
                            <span
                              className="px-2 py-1 rounded-pill fw-semibold"
                              style={{
                                backgroundColor: "#d1fae5",
                                color: "#065f46",
                                fontSize: "0.75rem",
                              }}
                            >
                              Active
                            </span>
                          )}

                          {booking.tripStatus === "completed" && (
                            <span
                              className="px-2 py-1 rounded-pill fw-semibold"
                              style={{
                                backgroundColor: "#f3f4f6",
                                color: "#1f2937",
                                fontSize: "0.75rem",
                              }}
                            >
                              Completed
                            </span>
                          )}

                          {booking.tripStatus === "cancelled" && (
                            <span
                              className="px-2 py-1 rounded-pill fw-semibold"
                              style={{
                                backgroundColor: "#fecaca",
                                color: "#7f1d1d",
                                fontSize: "0.75rem",
                              }}
                            >
                              Cancelled
                            </span>
                          )}
                        </TableCell>

                        <TableCell>
                          <IconButton className="icon-btn">
                            <FaEye
                              style={{ color: "#17a2b8" }}
                              onClick={() => gotoDetails(booking.activityLogId)}
                              className="icons"
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}

                    {getAllBookingById.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No Booking Found.
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                )}
              </Table>
            </div>
            <nav style={{ flexShrink: 0 }}>
          <ul className="pagination justify-content-center mt-3">
            <li className={`page-item ${page === 1 && "disabled"}`}>
              <button
                className="page-link"
                onClick={() => setPage((p) => Math.max(p - 1, 1))}
              >
                Previous
              </button>
            </li>

            {Array.from({ length: Math.min(5, pageCount) }, (_, i) => (
              <li
                key={i + 1}
                className={`page-item ${page === i + 1 && "active"}`}
              >
                <button className="page-link" onClick={() => setPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}

            {pageCount > 5 && (
              <>
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => setPage(pageCount)}
                  >
                    {pageCount}
                  </button>
                </li>
              </>
            )}

            <li className={`page-item ${page === pageCount && "disabled"}`}>
              <button
                className="page-link"
                onClick={() => setPage((p) => Math.min(p + 1, pageCount))}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
          </div>
        );
      // case "geofence":
      //   return (
      //     <div className="p-3">
      //       {" "}
      //       <div className="d-flex justify-content-between align-items-center mb-3">
      //         <h5>geofence</h5>
      //         <input
      //           type="text"
      //           placeholder="Search..."
      //           className="form-control w-25"
      //         />
      //       </div>
      //       <TableContainer component={Paper} style={{ padding: "10px" }}>
      //         <Table sx={{ minWidth: 700 }} aria-label="customized table">
      //           <TableHead>
      //             <TableRow>
      //               <TableCell>S.No</TableCell>
      //               <TableCell>Date</TableCell>
      //               <TableCell align="right">Description</TableCell>
      //               <TableCell align="right">Amount</TableCell>
      //               <TableCell align="right">Type</TableCell>
      //             </TableRow>
      //           </TableHead>
      //           <TableBody>
      //             {getAllIncome.map((item:any,index:number) => (
      //               <StyledTableRow key={index}>
      //                 <StyledTableCell component="th" scope="row">
      //                   {index + 1}
      //                 </StyledTableCell>
      //                 <StyledTableCell align="right">
      //                 {item.date
      //                 ? new Date(item.date).toLocaleDateString(
      //                     "en-GB"
      //                   )
      //                 : "--"}
      //                 </StyledTableCell>
      //                 <StyledTableCell align="right">{item.description}</StyledTableCell>
      //                 <StyledTableCell align="right">
      //                   {item.amount}
      //                 </StyledTableCell>
      //                 <StyledTableCell align="right">
      //                   {item.type}
      //                 </StyledTableCell>
      //               </StyledTableRow>
      //             ))}
      //           </TableBody>
      //         </Table>
      //       </TableContainer>
      //     </div>
      //   );
      case "income":
        return (
          <div>
            {" "}
            <div className="p-3">
              {" "}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5>income </h5>
                <input
                  type="text"
                  placeholder="Search..."
                  className="form-control w-25"
                />
              </div>
              <TableContainer component={Paper} style={{ padding: "10px" }}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <TableCell>S.No</TableCell>
                      <TableCell align="center">Date</TableCell>
                      <TableCell align="center">Description</TableCell>
                      <TableCell align="center">Amount</TableCell>
                      <TableCell align="center">Type</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getAllIncome.map((item: any, index: number) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell component="th" scope="row">
                          {index + 1}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.date
                            ? new Date(item.date).toLocaleDateString("en-GB")
                            : "--"}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.description}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.amount}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.type}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                    {getAllIncome.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No Income Found.
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div>
        <div className="container">
          <div className="row d-flex flex-wrap">
            <div className="col-md-3 mt-3 d-flex flex-column justify-content-center align-items-center d-md-block">
              <h3>Vehicle Details</h3>
              <Card
                style={{ width: "100%" }}
                sx={{
                  borderRadius: 2,
                  boxShadow: 3,
                  borderTop: "3px solid #1976d2", // blue top border
                }}
              >
                <CardContent>
                  <Stack spacing={1} alignItems="center" textAlign="center">
                    <Typography variant="h6" fontWeight={500}>
                      {getVehicleById?.vehicleName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {getVehicleById?.vehicleType}
                    </Typography>
                    <Chip
                      label="Active"
                      color="success"
                      size="small"
                      sx={{ fontWeight: 600 }}
                    />
                  </Stack>

                  <Divider sx={{ my: 2 }} />

                  <Box>
                    {[
                      ["Bookings", getAllBookingById?.length],
                      // ["Geofence", 4],
                      // ["Notifications", 0],
                    ].map(([label, value], index) => (
                      <React.Fragment key={label}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            py: 1,
                          }}
                        >
                          <Typography fontWeight={600}>{label}</Typography>
                          <Typography>{value}</Typography>
                        </Box>
                        {index < 2 && <Divider />}
                      </React.Fragment>
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </div>
            <div className="col-md-9">
              <div className="box mt-5">
                <div className="box-heading">
                  {tabs.map((tab) => (
                    <div
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`itemDv ${
                        activeTab === tab.id ? "activeTab" : ""
                      }`}
                    >
                      {" "}
                      <h6> {tab.label}</h6>
                    </div>
                  ))}
                </div>
                {renderContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleCard;
